<template>
  <div class="coinslist">
    <div class="titles">
      <span class="tradestitle"> بازار ها </span>
      <div class="pricebtns">
        <button
          @click.prevent="
            $router.push('/advancetrade/TOMAN/' + $route.params.tradeFrom)
          "
          :class="{ selectedprice: $route.params.tradeTo == 'TOMAN' }"
        >
          تومان
        </button>
        <button
          @click.prevent="
            $router.push('/advancetrade/TETHER/' + $route.params.tradeFrom)
          "
          :class="{ selectedprice: $route.params.tradeTo == 'TETHER' }"
        >
          تتر
        </button>
      </div>
      <div class="search-bar">
        <input type="text" placeholder="جستجو" v-model="search" />
      </div>
    </div>
    <div class="market">
      <div class="header-table">
        <span style="width: 120px"> بازار </span>
        <span> قیمت واحد </span>
        <span> تغییرات </span>
      </div>
      <div class="body-table">
        <div
          @click="reDirect($coins[coin.destCoinSymbol].coin)"
          v-for="(coin, index) in searchItem()"
          :key="index"
          class="coin-row"
        >
          <div class="coin">
            <img
              class="coin-icon"
              :src="$coins[coin.destCoinSymbol].link"
              alt=""
            />
            <span> {{ $coins[coin.destCoinSymbol].persianName }} </span>
          </div>
          <span>
            {{ $toLocal(coin.price, $coins[$route.params.tradeTo].precision) }}
          </span>
          <span
            class="list-success success"
            v-if="coin.price24hrChangePercent > 0"
          >
            {{ $toLocal(coin.price24hrChangePercent, 2) }}%+</span
          >
          <span class="list-fail fail" v-if="coin.price24hrChangePercent < 0">
            {{ $toLocal(Math.abs(coin.price24hrChangePercent), 2) }}%-
          </span>
          <span class="list-fail fail" v-if="coin.price24hrChangePercent == 0">
            0
          </span>
        </div>
      </div>
    </div>
    <span class="tradestitle"> آخرین معاملات </span>
  </div>
</template>
<script>
export default {
  name: "CoinList",
  props: ["tickerPrices"],
  data() {
    return {
      coins: [],
      search: "",
    };
  },
  methods: {
    searchItem() {
      if (!this.search) {
        return this.tickerPrices;
      } else {
        return this.tickerPrices.filter(
          (e) =>
            e.destCoinSymbol.startsWith(this.search.toUpperCase()) ||
            this.$coins[e.destCoinSymbol].code.startsWith(
              this.search.toUpperCase()
            ) ||
            this.$coins[e.destCoinSymbol].persianName.startsWith(this.search)
        );
      }
    },
    reDirect(e) {
      this.$router.push(
        "/advancetrade/" + this.$route.params.tradeTo + "/" + e
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  background: var(--light-grey);
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 4px;

  input {
    background: none;
  }
}

.tradestitle {
  font-weight: 400;
  font-size: clamp(14px, 1vw, 12px);
  color: var(--dark-grey);
}

.list-success {
  background-color: rgba(202, 235, 199, 1);
  padding: 2px 4px;
  border-radius: 2px;
}

.list-fail {
  background-color: rgba(255, 228, 228, 1);
  padding: 2px 4px;
  border-radius: 2px;
}

.market {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 200px;
  row-gap: 4px;
  overflow: hidden;

  .header-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: var(--box);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 12px 12px 4px;
    font-size: clamp(12px, 1vw, 14px);
    color: var(--grey);
  }

  .body-table {
    display: flex;
    flex-direction: column;
    padding: 0px 0px 12px;
    row-gap: 4px;
    max-height: 30vh;
    background: var(--box);
    font-size: clamp(10px, 1vw, 12px);
    height: 100%;
    overflow: scroll;

    img {
      width: 26px;
      height: 26px;
    }

    span {
      font-weight: 400;
      font-size: clamp(14px, 1vw, 12px);
    }

    .coin-row {
      cursor: pointer;
      padding: 4px 12px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

      .coin {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 8px;
        width: 120px;
      }
    }
  }
}

.selectedprice {
  background: var(--primary-color) !important;
  color: var(--white) !important;
  border-radius: 4px;
}

.coinslist {
  height: 100%;
  width: 32%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  justify-content: space-between;
}

.titles {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .pricebtns {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    background: var(--light-grey);
    padding: 4px 8px;
    width: 120px;

    button {
      cursor: pointer;
      width: 50%;
      background: transparent;
      border-radius: 4px;
      color: var(--grey);
      // padding: 4px 8px;
    }
  }
}

@media screen and (max-width: 450px) {
  .titles {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

@media only screen and (max-width: 1700px) {
  .body-table {
    overflow: scroll;
    max-height: 30vh;
  }
}

@media only screen and (max-width: 1000px) {
  .coinslist {
    width: 100%;
  }

  .pricebtns {
    width: 40% !important;
  }
}
</style>
